const Domain = "https://paroc.adtjcs.com/Api/";
export { Domain };
// http://rahulrajrahu33.pythonanywhere.com/
// https://www.marygiricollegebackend.xyz
